import Axios from 'axios';
import { OrderCircle_CONFIG } from '@/js/config.js';
const RESOURCE_NAME = OrderCircle_CONFIG.API_URL + 'customers';
export default {
  getAll() {
    return Axios.get(RESOURCE_NAME);
  },
  getCustomerURL() {
    return RESOURCE_NAME+ `/customers-list`;
  },
  getPendingCustomersCount() {
    return Axios.get(RESOURCE_NAME+'/pending-customers-count');
  },
  getCreateCustomerData(){
      return Axios.get(RESOURCE_NAME+'/info');
   },
  getAllCustomersQuickBooks() {
    return Axios.get(RESOURCE_NAME+'QuickBooks');
  },
  get(id) {
    return Axios.get(`${RESOURCE_NAME}/${id}`);
  },
  getCustomerData(id) {
    return Axios.get(`${RESOURCE_NAME}/${id}`);
  },

  edit(id) {
    return Axios.get(`${RESOURCE_NAME}/${id}/edit`);
  },

  create(data) {
    return Axios.post(RESOURCE_NAME, data);
  },

  update(id, data) {
    return Axios.put(`${RESOURCE_NAME}/${id}`, data);
  },

  delete(id) {
    return Axios.delete(`${RESOURCE_NAME}/${id}`);
  },

  patchRestoreBrandCustomer(customerId, data) {
    return Axios.post(`${RESOURCE_NAME}/${customerId}/restore`);
  },

  getBrandReps() {
    let brandRepsUrl = OrderCircle_CONFIG.API_URL + 'brand/reps';
    return Axios.get(`${brandRepsUrl}`);
  },
  // This method returns the url for remote source for datatable
  customerslistUrl(){
    return RESOURCE_NAME;
  },
  getBrandProductsList() {
    let brandProductsListUrl = OrderCircle_CONFIG.API_URL + 'brand/products-list';
    return Axios.get(`${brandProductsListUrl}`);
  },
  createNote(customerId, data) {
    let notesUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/notes';
    return Axios.post(`${notesUrl}`, data);
  },
  getNotes(customerId) {
    let notesUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/notes';
    return Axios.get(`${notesUrl}`);
  },
  deleteNote(customerId, noteId){
    let notesDeleteUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/note/' + noteId;
    return Axios.delete(`${notesDeleteUrl}`);
  },
  getShippingAddresses(customerId) {
    let shippingAddressUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/shipping-addresses';
    return Axios.get(`${shippingAddressUrl}`);
  },
  deleteShippingAddress(customerId, addressId){
    let shippingDelUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/shipping-addresses/' + addressId;
    return Axios.delete(`${shippingDelUrl}`);
  },
  getBillingAddresses(customerId) {
    let billingAddressUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/billing-addresses';
    return Axios.get(`${billingAddressUrl}`);
  },
  deleteBillingAddress(customerId, addressId){
    let shippingDelUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/billing-addresses/' + addressId;
    return Axios.delete(`${shippingDelUrl}`);
  },
  createStoreCredit(customerId, data) {
    let creditNoteUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/credit-note';
    return Axios.post(`${creditNoteUrl}`, data);
  },
  enableCustomer(customerId) {
    let creditNoteUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/enable';
    return Axios.post(`${creditNoteUrl}`, {});
  },
  disableCustomer(customerId) {
    let creditNoteUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/disable';
    return Axios.post(`${creditNoteUrl}`, {});
  },
  customersFiles(data, customerId){
    const headers = { "Content-Type": "multipart/form-data" };
    return Axios.post(OrderCircle_CONFIG.API_URL+ `customers/${customerId}/files`, data, {
      headers
    });
  },

  getCustomerFiles(customerId) {
    let customerFileUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/files';
    return Axios.get(`${customerFileUrl}`);
  },

  getCustomerId() {
    let customerFileUrl = OrderCircle_CONFIG.API_URL + 'customers/getCustomerId';
    return Axios.get(`${customerFileUrl}`);
  },
  deleteCustomerFile(customerId, fileId) {
    let delCustomerFileUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/files/' + fileId; 
    return Axios.delete(`${delCustomerFileUrl}`);
  },
  createBrandFile(data){
    const headers = { "Content-Type": "multipart/form-data" };
      return Axios.post(OrderCircle_CONFIG.API_URL + "brand-files/upload", data, {
      headers,
    });
  },
  getBrandFiles() {
    let customerFileUrl = OrderCircle_CONFIG.API_URL + 'brand-files';
    return Axios.get(`${customerFileUrl}`);
  },
  downloadBrandFile(fileId, brandId, download = '1') {
    let downloadUrl = OrderCircle_CONFIG.API_URL + 'brand-files/brand/show/' + brandId + '/' + fileId + '/' + download;
    return Axios.get(`${downloadUrl}`, { responseType: 'blob' });
  },
  deleteBrandFile(fileId) {
    let delCustomerFileUrl = OrderCircle_CONFIG.API_URL + 'brand-files/' + fileId; 
    return Axios.delete(`${delCustomerFileUrl}`);
  },
  
  deleteCartProducts(id){
    return Axios.delete(OrderCircle_CONFIG.API_URL + 'customers'+'/cart/products/delete/'+ id);
  },
  getAllCartProducts( ){
    return Axios.get(OrderCircle_CONFIG.API_URL + 'customers'+'/cart/products');
  },
  updateCartProductQuantity(data){
    return Axios.post(OrderCircle_CONFIG.API_URL+ 'customers'+'/cart/products', data);
  },
  incrementCartProduct(data){
    return Axios.post(OrderCircle_CONFIG.API_URL+ 'customers'+'/incrementCartProduct', data);
  },
  decrementCartProduct(data){
    return Axios.post(OrderCircle_CONFIG.API_URL+ 'customers'+'/decrementCartProduct', data);
  },
  createAuthorizePaymentCardInfo(data) {
    let authorizeNetUrl = OrderCircle_CONFIG.API_URL + 'customer/authorize-payment-info';
    return Axios.post(`${authorizeNetUrl}`, data);
  },
  updateAuthorizePaymentCardInfo(customerId, data) {
    let authorizeNetUrl = OrderCircle_CONFIG.API_URL + 'customer/authorize-payment-info/' + customerId;
    return Axios.put(`${authorizeNetUrl}`, data);
  },
  deleteAuthorizePaymentCardInfo(data) {
    let authorizeNetUrl = OrderCircle_CONFIG.API_URL + 'customer/authorize-payment-info/remove-card';
    return Axios.put(`${authorizeNetUrl}`, data);
  },
  customerPaymentInfos(){
    let authorizeNetUrl = OrderCircle_CONFIG.API_URL + 'shop/customer-payment-info';
    return Axios.get(`${authorizeNetUrl}`);
  },
  customerAuthorizeNetCards(customerId){
    let authorizeNetUrl = OrderCircle_CONFIG.API_URL + 'customer/authorize-payment-info/' + customerId;
    return Axios.get(`${authorizeNetUrl}`);
  },
  getBrandCurrencyList() {
    let brandCurrencyListUrl = OrderCircle_CONFIG.API_URL + 'brand/brand-currency';
    return Axios.get(`${brandCurrencyListUrl}`);
  },
  setAuthorizeNetCardAsDefault(data) {
    let authorizeNetUrl = OrderCircle_CONFIG.API_URL + 'customer/authorize-card-set-default';
    return Axios.post(`${authorizeNetUrl}`, data);
  },
  getStripeBillingIntent(customerId, customerType){
      let stripeIntentUrl = OrderCircle_CONFIG.API_URL + 'customer/stripe-billing-setup-intent/' + customerId + '/' + customerType;
      return Axios.get(`${stripeIntentUrl}`);
  },
  saveStripeBillingPaymentMethod(data){
    let stripePaymentsUrl = OrderCircle_CONFIG.API_URL + 'customer/stripe-billing-payments';
    return Axios.post(`${stripePaymentsUrl}`, data);
  },
  getStripeBillingPaymentMethods(customerId, customerType){
    let stripeIntentUrl = OrderCircle_CONFIG.API_URL + 'customer/stripe-billing-payment-methods/' + customerId + '/' + customerType;
    return Axios.get(`${stripeIntentUrl}`);
  },
  removeStripeBillingPaymentMethod(data){
      let stripeIntentUrl = OrderCircle_CONFIG.API_URL + 'customer/stripe-billing-remove-payment';
      return Axios.post(`${stripeIntentUrl}`, data);
  },

  getBrandPromoCode() {
    let brandRepsUrl = OrderCircle_CONFIG.API_URL + 'settings/brand-promo-codes';
    return Axios.get(`${brandRepsUrl}`);
  },
  getTaxRate() {
    let brandTaxRateUrl = OrderCircle_CONFIG.API_URL + 'brand/tax-rate';
    return Axios.get(`${brandTaxRateUrl}`);
  },
  customerResendWelcomeEmail(id){
    let resendEmailURL = OrderCircle_CONFIG.API_URL + 'customers/' + id + '/welcome-email';
    return Axios.get(`${resendEmailURL}`)
  },
  getPendingCustomersList() {
    return RESOURCE_NAME + "/pending-customers/list";
  },
  getPendingCustomerData(Id){
      let PendingCustomerUrl = OrderCircle_CONFIG.API_URL + 'customers/pending-customers/' + Id;
      return Axios.get(`${PendingCustomerUrl}`);
  },
  deletePendingCustomer(Id) {
    let deletePendingCustomerUrl = OrderCircle_CONFIG.API_URL + 'customers/pending-customers/' + Id; 
    return Axios.delete(`${deletePendingCustomerUrl}`);
  },
  createApprovePendingCustomer(Id, data) {
    let approvePendingCustomerUrl = OrderCircle_CONFIG.API_URL + 'customers/pending-customers/' + Id;
    return Axios.post(`${approvePendingCustomerUrl}`, data);
  },
  addNotificationEmail(data){
    let Url = OrderCircle_CONFIG.API_URL + 'customers/notification-email';
    return Axios.post(`${Url}`, data)
  },
  /*
    Stripe Subscription methods
  */

  getStripeSubscriptionIntent(customerId, customerType ){
    let stripeIntentUrl = OrderCircle_CONFIG.API_URL + 'customer/stripe-subscription-setup-intent/' + customerId + '/' + customerType;
    return Axios.get(`${stripeIntentUrl}`);
  },
  saveStripeSubscriptionPaymentMethod(data){
    let stripePaymentsUrl = OrderCircle_CONFIG.API_URL + 'customer/stripe-subscription-payments';
    return Axios.post(`${stripePaymentsUrl}`, data);
  },
  getStripeSubscriptionPaymentMethods(customerId,customerType){
    let stripeIntentUrl = OrderCircle_CONFIG.API_URL + 'customer/stripe-subscription-payment-methods/' + customerId + '/' + customerType;
    return Axios.get(`${stripeIntentUrl}`);
  },
  removeStripeSubscriptionPaymentMethod(data){
    let stripeIntentUrl = OrderCircle_CONFIG.API_URL + 'customer/stripe-subscription-remove-payment';
    return Axios.post(`${stripeIntentUrl}`, data);
  },
  saveStripeBankAccount(data){
    let stripePaymentsUrl = OrderCircle_CONFIG.API_URL + 'customer/stripe-bank-account';
    return Axios.post(`${stripePaymentsUrl}`, data);
  },
  getStripeBillingBankAccounts(customerId, customerType){
    let stripeIntentUrl = OrderCircle_CONFIG.API_URL + 'customer/stripe-billing-bank-accounts/' + customerId + '/' + customerType;
    return Axios.get(`${stripeIntentUrl}`);
  },
  removeStripeBillingBankAccount(data){
    let stripeIntentUrl = OrderCircle_CONFIG.API_URL + 'customer/stripe-billing-remove-bank-account';
    return Axios.post(`${stripeIntentUrl}`, data);
  },
  verifyStripeBillingBankAccount(data){
    let stripeIntentUrl = OrderCircle_CONFIG.API_URL + 'customer/stripe-billing-verify-bank-account';
    return Axios.post(`${stripeIntentUrl}`, data);
  },
  invoicePDF(customerId,orderNumber){
    return Axios.get(`${RESOURCE_NAME}/${customerId}/invoices/${orderNumber}`);
  },
  sendInvoiceToCustomer(customerId,orderNumber){
    return Axios.get(`${RESOURCE_NAME}/${customerId}/invoices/${orderNumber}/resend`);
  },

  // Payflow Pro related methods
  createPayflowPaymentCardInfo(data) {
    let authorizeNetUrl = OrderCircle_CONFIG.API_URL + 'customer/payflow-payment-info';
    return Axios.post(`${authorizeNetUrl}`, data);
  },
  updatePaflowPaymentCardInfo(customerId, data) {
    let authorizeNetUrl = OrderCircle_CONFIG.API_URL + 'customer/payflow-payment-info/' + customerId;
    return Axios.put(`${authorizeNetUrl}`, data);
  },
  deletePayflowPaymentCardInfo(data) {
    let authorizeNetUrl = OrderCircle_CONFIG.API_URL + 'customer/payflow-payment-info/remove-card';
    return Axios.put(`${authorizeNetUrl}`, data);
  },
  customerPayflowCards(customerId){
    let authorizeNetUrl = OrderCircle_CONFIG.API_URL + 'customer/payflow-payment-info/' + customerId;
    return Axios.get(`${authorizeNetUrl}`);
  },
  setPayflowCardAsDefault(data) {
    let authorizeNetUrl = OrderCircle_CONFIG.API_URL + 'customer/payflow-card-set-default';
    return Axios.post(`${authorizeNetUrl}`, data);
  },
  // getSquareBillingIntent(customerId, customerType){
  //     let stripeIntentUrl = OrderCircle_CONFIG.API_URL + 'customer/square-billing-setup-intent/' + customerId + '/' + customerType;
  //     return Axios.get(`${stripeIntentUrl}`);
  // },
  // saveSquareBillingPaymentMethod(data){
  //   let squarePaymentsUrl = OrderCircle_CONFIG.API_URL + 'customer/square-billing-payments';
  //   return Axios.post(`${squarePaymentsUrl}`, data);
  // },
  // getSquareBillingPaymentMethods(customerId, customerType){
  //   let squareIntentUrl = OrderCircle_CONFIG.API_URL + 'customer/square-billing-payment-methods/' + customerId + '/' + customerType;
  //   return Axios.get(`${squareIntentUrl}`);
  // },
  getCustomerSquareCards(customerId){
    let squareCardUrl = OrderCircle_CONFIG.API_URL + 'square-cards/customer-card/' + customerId;
    return Axios.get(`${squareCardUrl}`);
  },
  createCustomerSquareCards(data) {
    let squareCardUrl = OrderCircle_CONFIG.API_URL + 'square-cards';
    return Axios.post(`${squareCardUrl}`, data);
  },
  defaultCustomerSquareCards(data) {
    let squareCardUrl = OrderCircle_CONFIG.API_URL + 'square-cards/set-default';
    return Axios.post(`${squareCardUrl}`, data);
  },
  deleteCustomerSquareCards(id) {
    let squareCardUrl = OrderCircle_CONFIG.API_URL + 'square-cards/remove-card/'+id;
    return Axios.delete(`${squareCardUrl}`);
  },
  getSquareCustomerLocation() {
    let squareCardUrl = OrderCircle_CONFIG.API_URL + 'square-cards/location';
    return Axios.get(`${squareCardUrl}`);
  },
  saveCustomView(data) {
    let url = RESOURCE_NAME + '/save-custom-view';
    return Axios.post(url, data);
  },
  async getAllCustomViews() {
      return await Axios.get(RESOURCE_NAME + '/get-all-custom-views');
  },
  deleteCustomView(data) {
    return Axios.post(RESOURCE_NAME + '/delete-custom-view', data);
  },
  getCombineInvoices(customerId,data) {
    return Axios.post(RESOURCE_NAME +'/' + customerId + '/combine-invoices', data, { responseType: 'blob' });
},
getAllCustomersQuickBooksList(token) {
  return RESOURCE_NAME+'/customers-list-quickbooks';
},
getAllCustomersOdooList(token) {
  return RESOURCE_NAME+'/customers-list-odoo';
},
downloadCustomerFile(customerId, fileId) {
    let downloadUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/show/' + fileId + '/download';
    return Axios.get(`${downloadUrl}`, { responseType: 'blob' });
  },
};
